import { createRoot } from 'react-dom/client'
import './index.css';
import App from './App';
import AccountProvider from 'context/AccountContext';
import UserProvider from 'context/UserContext';
import Auth from "components/Authentication/Auth"
import { BrowserRouter } from "react-router-dom";
import ErrorFaultProvider from 'context/ErrorFaultContext';
import { ErrorFallback } from 'components/ErrorFallback';
import { ScrollToTop } from 'utility/ScrollToTop';

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);
root.render(
  <ErrorFallback>
    <BrowserRouter>
      <ErrorFaultProvider>
        <Auth>
          <AccountProvider>
            <UserProvider>
              <App />
              <ScrollToTop />
            </UserProvider>
          </AccountProvider>
        </Auth>
      </ErrorFaultProvider>
    </BrowserRouter>
  </ErrorFallback>
  );
